import { Location } from '../types';

export function toString(location: Location): string {
  const str = location.name;
  if (location.parent) {
    return `${str}, ${toString(location.parent)}`;
  }
  return str;
}
